import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import Panel from '@ts-core/components/Panel/Panel';
import Typography from '@ts-core/components/Typography';

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.secondary.contrastText,
    fontWeight: 700,
  },
}));

const DashboardHeader = (props) => {
  const { course, loading, children } = props;
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Panel color={theme.palette.secondary.main}>
      <Box minHeight={160} display="flex" flexDirection="column" mt={2}>
        <Typography
          variant="h4"
          className={classes.title}
          loading={loading}
          skeletonWidth={280}
          skeletonHeight={40}
        >
          {course.name}
        </Typography>
        {children}
      </Box>
    </Panel>
  );
};

DashboardHeader.propTypes = {
  course: PropTypes.object,
  loading: PropTypes.bool,

  children: PropTypes.node,
};

DashboardHeader.defaultProps = {
  course: {},
  loading: false,
  children: undefined,
};

export default DashboardHeader;
